import { ApiPermissions } from "../../services/volateq-api/api-permissions";
import { CustomerTokenResult } from "../../services/volateq-api/api-schemas/auth-schema";
import { SimpleTaskSchema } from "../../services/volateq-api/api-schemas/task-schema";
import { BaseComponent } from "../base-component/base-component";

export abstract class BaseAuthComponent extends BaseComponent {
  get isAdmin(): boolean {
    return !this.isHiddenSuperAdmin && this.store.auth.isVolateqAdmin;
  }

  get isHiddenSuperAdmin(): boolean {
    return this.store.auth.isHiddenAdmin;
  }

  get selectedCustomer(): CustomerTokenResult | undefined {
    if (this.isAdmin || this.isHiddenSuperAdmin) {
      return this.store.auth.customer;
    }

    return undefined;
  }

  get p(): typeof ApiPermissions {
    return ApiPermissions;
  }

  hasPerm(...p: ApiPermissions[]): boolean {
    return this.store.auth.hasPermission(...p);
  }

  hasAdminPerm(...p: ApiPermissions[]): boolean {
    return this.isAdmin && this.hasPerm(...p);
  }

  hasReadTaskPerm(task: SimpleTaskSchema): boolean {
    return task.is_admin ? this.hasPerm(this.p.READ_ADMIN_TASK) : this.hasPerm(this.p.READ_TASK);
  }

  get hasPermPlantView(): boolean {
    return this.hasPerm(ApiPermissions.READ_ANALYSIS_RESULT) ||
      this.hasPerm(ApiPermissions.READ_DIGITAL_TWIN_VISUALIZATION) ||
      this.hasPerm(ApiPermissions.READ_OBSERVATION) ||
      this.hasPerm(ApiPermissions.READ_ALL_PLANT);
  }
}
